import { AspectRatio, Box, Flex, FlexProps, Stack, Skeleton, SkeletonText } from '@chakra-ui/react';
import { useTheme } from '@chakra-ui/react';

interface SkeletonListingCardProps {
  flexProps?: FlexProps;
}

const SkeletonListingCard = ({ flexProps }: SkeletonListingCardProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Flex direction="column" overflow="hidden" {...flexProps}>
      <Stack
        spacing={{ base: '4', md: '5' }}
        justifyContent="space-between"
        style={{ flexGrow: 1 }}
      >
        {/* Image skeleton */}
        <Box position="relative">
          <AspectRatio ratio={8 / 7}>
            <Skeleton
              borderRadius={{ base: theme.border_radius.border_radius_1 }}
              startColor="gray.200"
              endColor="gray.300"
            />
          </AspectRatio>
        </Box>

        <Stack height="full" spacing={3}>
          {/* Title skeleton - 2 lines */}
          <Box minHeight="54px">
            <SkeletonText noOfLines={2} spacing="3" skeletonHeight="18px" />
          </Box>

          {/* Price skeleton */}
          <Skeleton height="21px" width="80px" startColor="gray.200" endColor="gray.300" />

          {/* Attributes/metadata skeleton */}
          <Box pt={2}>
            <Skeleton
              height="16px"
              width="120px"
              mb={2}
              startColor="gray.200"
              endColor="gray.300"
            />
            <Skeleton height="16px" width="100px" startColor="gray.200" endColor="gray.300" />
          </Box>
        </Stack>
      </Stack>
    </Flex>
  );
};

export default SkeletonListingCard;
